/* eslint-disable @typescript-eslint/no-unused-vars */

export enum LinkOptions {
  ANDROID_DOWNLOAD,
  CHINA_DOWNLOAD,
  JEEVES,
  PLAY_CONSOLE_ANR,
  PLAY_CONSOLE_LOW_REVIEW,
  PLAY_CONSOLE_NATIVE_CRASH,
  SENTRY_DASHBOARDS,
  SENTRY_ISSUE_FEED,
}

// See https://github.com/duolingo/duolingo-android/pull/30861 for the S3 path migration.
const afterAndroidRename = (majorMinor: string) => {
  const [major, minor] = majorMinor.split(".");
  return major > "5" || (major === "5" && minor >= "156");
};

export const linksMap: Record<
  LinkOptions,
  (majorMinor: string, patch: number, build: number) => string
> = {
  [LinkOptions.JEEVES]: (majorMinor, patch, build) =>
    `https://jeeves.duolingo.com/en/discovery?q=app_version%3A"${majorMinor}.${patch}+(${build})+play"`,
  [LinkOptions.PLAY_CONSOLE_ANR]: (majorMinor, patch, build) =>
    `https://play.google.com/console/u/0/developers/6957685454452609502/app/4972578003127492781/vitals/crashes?errorType=ANR&days=28&installedFrom=PLAY_STORE&versionCode=${build}`,
  [LinkOptions.PLAY_CONSOLE_LOW_REVIEW]: (majorMinor, patch, build) =>
    `https://play.google.com/console/u/0/developers/6957685454452609502/app/4972578003127492781/user-feedback/reviews?starCounts=1%2C2&versionCodes=${build}`,
  [LinkOptions.PLAY_CONSOLE_NATIVE_CRASH]: (majorMinor, patch, build) =>
    `https://play.google.com/console/u/0/developers/6957685454452609502/app/4972578003127492781/vitals/crashes?days=28&installedFrom=PLAY_STORE&errorType=CRASH&versionCode=${build}`,
  [LinkOptions.SENTRY_DASHBOARDS]: (majorMinor, patch, build) =>
    `https://duolingo-sentry.sentry.io/dashboard/157946/?environment=release&globalFilter=&project=4507867640037376&release=com.duolingo%40${majorMinor}.${patch}%2B${build}&statsPeriod=7d`,
  [LinkOptions.SENTRY_ISSUE_FEED]: (majorMinor, patch, build) =>
    `https://duolingo-sentry.sentry.io/issues/?environment=release&project=4507867640037376&query=is%3Aunresolved%20%21error.type%3AApplicationNotResponding%20release%3Acom.duolingo%40${majorMinor}.${patch}%2B${build}&referrer=issue-list&statsPeriod=7d`,
  [LinkOptions.ANDROID_DOWNLOAD]: (majorMinor, patch, build) =>
    `https://test-insights.internal.duolingo.com/platform/jenkins/download-from-s3?s3Path=s3://duolingo-android-builds.internal.duolingo.com/release/GooglePlay/${majorMinor}.${patch}.${build}/${
      afterAndroidRename(majorMinor) ? "Duo" : "duo"
    }.${
      afterAndroidRename(majorMinor) ? "playRelease" : "playrelease"
    }.${majorMinor}.${patch}.apk&autoDownload=true`,
  [LinkOptions.CHINA_DOWNLOAD]: (majorMinor, patch, build) =>
    `https://test-insights.internal.duolingo.com/platform/jenkins/download-from-s3?s3Path=s3://duolingo-android-builds.internal.duolingo.com/release/China/${majorMinor}.${patch}.${build}/${
      afterAndroidRename(majorMinor) ? "Duo" : "duo"
    }.${
      afterAndroidRename(majorMinor) ? "chinaRelease" : "chinarelease"
    }.${majorMinor}.${patch}.apk&autoDownload=true`,
};
